import { Pipe } from '@angular/core';
var MaxPipe = (function () {
    function MaxPipe() {
    }
    MaxPipe.prototype.transform = function (arr) {
        return Array.isArray(arr)
            ? Math.max.apply(Math, arr) : arr;
    };
    MaxPipe.decorators = [
        { type: Pipe, args: [{ name: 'max' },] },
    ];
    /** @nocollapse */
    MaxPipe.ctorParameters = function () { return []; };
    return MaxPipe;
}());
export { MaxPipe };
//# sourceMappingURL=max.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/max.js
// module id = 261
// module chunks = 4